import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'reactstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import LoadingAbsolute from '../../LoadingAbsolute'
import CanliYayinSvg from '../../../assets/icons/CanliYayinSvg'
import Header from '../../Header'
import HobiListItem from './HobiListItem'
import Empty from '../../Empty'
import axios from 'axios'

const HobiBasvuruList = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [youtubeUrl, setYoutubeUrl] = useState(null)

  const getData = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/hobi-bahceleri-basvuru/list`, {
        headers: {
          Authorization: JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        setData(res.data.list)
        setYoutubeUrl(res.data.youtube_url)
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getData()
  }, [state])

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header onClick={() => navigate('/')} />
        </div>
        {youtubeUrl && ( //youtubeUrl linki varsa
          <>
            <div className='hobiTitle' style={{ margin: '.5rem 1rem 1rem 1rem', fontSize: '16px' }}>
              Hak Sahipliği Kurası
            </div>
            <div className={'hobiListDesc'}>Noter huzurunda çekilen hobi bahçeleri canlı yayın kurasına aşağıdaki bağlantı üzerinden ulaşabilirsiniz.</div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1.5rem',
                marginBottom: '2rem',
              }}
            >
              <Button
                block
                onClick={() => {
                  window.open(youtubeUrl)
                }}
                style={{
                  marginRight: '1rem',
                  marginLeft: '1rem',
                  backgroundColor: '#C4302B',
                  borderColor: '#C4302B',
                  borderRadius: '10px',
                  //   padding: '.5rem 0',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '.5rem',
                  }}
                >
                  <CanliYayinSvg width={'1rem'} />
                  {loading ? (
                    <Spinner
                      size={'sm'}
                      // type="grow"
                    />
                  ) : (
                    'Canlı İzle'
                  )}
                </div>
              </Button>
            </div>
          </>
        )}
        {!loading ? (
          data?.length > 0 ? (
            data.map((item) => {
              return <HobiListItem key={item.id} title={item.title} basvuru_tarihi={item.basvuru_tarihi} basvuru_no={item.basvuru_no} kura_durum={item.kura_durum} kura_tarihi={item.kura_tarihi} />
            })
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Empty hobi={true} />
            </div>
          )
        ) : null}
      </div>
    </>
  )
}

export default HobiBasvuruList
